import { inRange, includes } from "lodash";

import { AcquiredDateChoices, ArtistResaleInput, PaymentStatuses, ResaleStatuses } from "@generated/graphql";

import { eligibility_date, threshold_price } from "@common/rrs_constants";
import { ReciprocalCountries } from "@common/status_enums";

const validate_eligibility = (
  sale_date: Date,
  sale_price: number,
  threshold_price: number,
  eligibility_date: Date,
  acquired_date_choice: AcquiredDateChoices,
  artistInput: ArtistResaleInput,
): boolean => {
  const { provisional_is_artist_alive, provisional_artist_yod, provisional_artist_country } = artistInput;
  if (acquired_date_choice === AcquiredDateChoices.VOLUNTARY) {
    return true;
  } else if (acquired_date_choice === AcquiredDateChoices.YES) {
    const currentYear = new Date().getFullYear();
    const hasMetResaleThreshold = sale_date > eligibility_date && sale_price >= threshold_price;
    const hasMetArtistRequirement =
      !provisional_is_artist_alive && provisional_artist_yod
        ? inRange(provisional_artist_yod, currentYear - 70, currentYear + 1)
        : true;
    const hasMetCountryRequirement = includes(ReciprocalCountries, provisional_artist_country);
    return hasMetResaleThreshold && hasMetArtistRequirement && hasMetCountryRequirement;
  } else {
    return false;
  }
};

export const validateResaleStatus = (
  sale_date: Date,
  sale_price: number,
  acquired_date_choice: AcquiredDateChoices,
  artistInput: ArtistResaleInput,
): ResaleStatuses => {
  const eligible = validate_eligibility(
    sale_date,
    sale_price,
    threshold_price,
    eligibility_date,
    acquired_date_choice,
    artistInput,
  );
  if (eligible) {
    return ResaleStatuses.PROVISIONALLY_ELIGIBLE;
  } else {
    return ResaleStatuses.PROVISIONALLY_INELIGIBLE;
  }
};

export const paymentStatusFromResale = (resale_status: ResaleStatuses): PaymentStatuses => {
  switch (resale_status) {
    case ResaleStatuses.PROVISIONALLY_INELIGIBLE:
      return PaymentStatuses.NOT_APPLICABLE;
    case ResaleStatuses.PROVISIONALLY_ELIGIBLE:
      return PaymentStatuses.PENDING;
    case ResaleStatuses.RESEARCH_REQUIRED:
      return PaymentStatuses.HOLD_PERIOD;
    default:
      return PaymentStatuses.NOT_APPLICABLE;
  }
};
